import React from 'react';

const OrderSummary = ({ service, company, ourFee, stateFee, total, discountPercentage = 0 }) => {
  const pct = parseInt(discountPercentage || 0, 10);
  const safeOurFee = parseFloat(ourFee) || 0;
  const safeStateFee = parseFloat(stateFee) || 0;
  const discountAmount = pct > 0 ? Math.round(safeOurFee * pct) / 100 : 0;
  const finalTotal = pct > 0
    ? Math.round(((safeOurFee - discountAmount) + safeStateFee) * 100) / 100
    : (total !== undefined ? parseFloat(total) : safeOurFee + safeStateFee);

  return (
    <div className="bg-[#111827] border border-gray-800 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-white mb-4">Order Summary</h3>

      <div className="space-y-3 mb-6">
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Service</span>
          <span className="text-white">{service?.name}</span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Company</span>
          <span className="text-white">{company?.company_name}</span>
        </div>

        {company?.state_of_formation && (
          <div className="flex justify-between text-sm">
            <span className="text-gray-400">State</span>
            <span className="text-white">{company.state_of_formation}</span>
          </div>
        )}
      </div>

      <div className="border-t border-gray-800 pt-4 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Service Fee</span>
          <span className="text-white">${safeOurFee.toFixed(2)}</span>
        </div>

        {pct > 0 && discountAmount > 0 && (
          <div className="flex justify-between text-sm" data-testid="partner-discount-line-details">
            <span className="text-[#059669]">Partner Discount ({pct}%)</span>
            <span className="text-[#059669]">−${discountAmount.toFixed(2)}</span>
          </div>
        )}

        {safeStateFee > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-gray-400">State Fee</span>
            <span className="text-white">${safeStateFee.toFixed(2)}</span>
          </div>
        )}

        <div className="flex justify-between text-lg font-semibold pt-2 border-t border-gray-800">
          <span className="text-white">Total</span>
          <span className="text-[#059669]">${finalTotal.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
